var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EventStormingModelCanvas',{key:_vm.componentKey,attrs:{"render-count":_vm.componentKey},on:{"forceUpdateKey":function($event){return _vm.forceRerender()}}})}
var staticRenderFns = []

export { render, staticRenderFns }